import { useEffect, useState } from "react";
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { useMessage } from "../../global-components/src";
import { useAuth } from "../../global-components/src";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { useTranslation } from 'react-i18next';

const DepriveProfile = () => {
    const [forMe, setForME] = useState(false);
    const [forFollowing, setFollowing] = useState(false);
    const [loading, setLoading] = useState(false);
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const { token } = useAuth();

    const updatePrivacy = async() =>{
        const url = PACOCA_API_URL + `/user/deprive`;

        if (loading) return;
        setLoading(true);

        try {
            const response = await axios.post(url, {
                for_me: forMe, for_following: forFollowing
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;
            setMessage(data.message, "success")
            
        } catch (err: any) {
            setLoading(true);
            if(err.status == 404){
                return
            }
            if(err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

            if(err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");
            
            if (err.response) {
                // O servidor respondeu com um código de erro
                console.error("Erro no servidor:", err.response.status, err.response.data);
                setMessage(err.response.data.message || "Erro no servidor!", "error");
            } else if (err.request) {
                // A requisição foi feita, mas não houve resposta
                console.error("Nenhuma resposta do servidor:", err.request);
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                // Outro tipo de erro (ex: erro de configuração)
                console.error("Erro inesperado:", err.message);
                setMessage("Ocorreu um erro inesperado!", "error");
            }
            console.error('Erro:', err);
        } finally {
            setLoading(false);
        }
    }

    const getData = async() =>{
        const url = PACOCA_API_URL + `/user`;

        if (loading) return;
        setLoading(true);

        try {
            const response = await axios.get(`${PACOCA_API_URL}/user/privacy`, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if(response.data.privacy == 1){
                setForME(true);
                setFollowing(false);
            }
            if(response.data.privacy == 2){
                setForME(false);
                setFollowing(true);
            }
        } catch (err: any) {
            setLoading(true);
            if(err.status == 404){
                return
            }
            if(err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

            if(err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");
            
            if (err.response) {
                // O servidor respondeu com um código de erro
                console.error("Erro no servidor:", err.response.status, err.response.data);
                setMessage(err.response.data.message || "Erro no servidor!", "error");
            } else if (err.request) {
                // A requisição foi feita, mas não houve resposta
                console.error("Nenhuma resposta do servidor:", err.request);
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                // Outro tipo de erro (ex: erro de configuração)
                console.error("Erro inesperado:", err.message);
                setMessage("Ocorreu um erro inesperado!", "error");
            }
            console.error('Erro:', err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() =>{
        getData()
    }, [])

    return (
        <>
             <Screen paddingTopTitle={true} title="Privar Perfil">
                <Helmet>
                        <title>Paçoca - Privacidade</title>
                        <meta name="description" content={`Altere a privacidade da sua conta no Paçoca, a rede dos brasileiros!`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Privacidade}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - Privacidade - Rede Social`}/>
                        <meta property="og:description" content={`Altere a privacidade da sua conta no Paçoca, a rede dos brasileiros`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Privacidade - Rede Social`}/>
                        <meta name="twitter:description" content={`Seja Altere a privacidade da sua conta no Paçoca, a rede dos brasileiros`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <>
                    <div className="padding-big-screen">
                        <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                            <input onChange={() => {setForME(!forMe); setFollowing(false)}} checked={forMe} className="form-check-input" type="checkbox" id="for_me" name="for_me"/>
                            <label className="form-check-label cursor-pointer" htmlFor="for_me"><h5 style={{margin: 0}}>Para mim</h5></label>
                        </div>
                        <p>Apenas você pode visualizar suas publicações e foto de perfil</p>

                        <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                            <input onChange={() => {setFollowing(!forFollowing);setForME(false); }} checked={forFollowing} className="form-check-input" type="checkbox" id="punds" name="punds"/>
                            <label className="form-check-label cursor-pointer" htmlFor="punds"><h5 style={{margin: 0}}>Seguindo</h5></label>
                        </div>
                        <p>Quem você segue pode visualizar suas publicações e foto de perfil</p>
                    
                        <button disabled={loading} onClick={updatePrivacy} className="btn btn-blue w-100 mt-5">
                            {loading ? (
                                <Spinner size="20px"/>
                            ) : (
                                <div>
                                    Salvar
                                </div>
                            )}
                        </button>
                    </div>
                </>
            </Screen>
        </>
    );
};

export default DepriveProfile;